import FormException from '@/lib/exceptions/form-exception';

class ModelsStore {
  constructor() {
    this.__models = {};
    this.__klassModels = {};
  }

  modelForId(modelType, modelId) {
    const model = this.__models[modelType][modelId];

    if (!model) {
      throw new FormException('Can not create model if not cached');
    }

    return model;
  }

  modelForName(modelType, modelName) {
    const models = Object.values(this.__models[modelType]);
    const model = models.find(m => m.name === modelName);

    if (!model) {
      throw new FormException('Can not create model if not cached');
    }

    return model;
  }

  addInstance(model) {
    this.__models[model.constructor.$modelType][model.id] = model;
  }

  registerClass(klass) {
    this.__klassModels[klass.$modelType] = klass;
    this.__models[klass.$modelType] = {};
  }
}

const singleton = new ModelsStore();

export default singleton;
